export default __webpack_public_path__ + "static/media/circle-plus-svgrepo.36d1869b.svg";